// This file is compiled by esbuild.

// To reference this file, add <%= javascript_include_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import "./src/jquery";
import "./src/lodash";

import './vendor';
import './controllers';

import '../javascript/lib/ajaxWaitingState';
import '../javascript/lib/refreshCSRFTokens';
import { checkForInitYuupMap } from '../javascript/lib/map';
import '../javascript/lib/mapMulitpleMarkers';
import '../javascript/lib/confirmBeforeExitForm';
import '../javascript/lib/searchFilters';
import '../javascript/lib/turbolinksBeforeCache';
import '../javascript/lib/autoSubmitForm';
import '../javascript/lib/initSortable';
import '../javascript/lib/initFacebookLogin';
import initValidation from '../javascript/lib/validateFields';
import initBookingCalendar from '../javascript/lib/bookingCalendar';
import initSupplierCalendar from '../javascript/lib/supplierCalendar';
import initfilterCalendar from '../javascript/lib/filterCalendar';
import initPostcodeLookups from '../javascript/lib/lookupPostcodes';
import initStickyBar from '../javascript/lib/stickyBar';
import experienceAnimationViewportCheck from '../javascript/lib/experienceAnimationViewportCheck';
import turbolinksScrollPersistence from '../javascript/lib/turbolinksScrollPersistence';
import initTabNavigation from '../javascript/lib/tabNavigation';

document.addEventListener('turbolinks:load', () => { console.log("turbolinks loaded") });
document.addEventListener("DOMContentLoaded", () => { console.log("page loaded") });

document.documentElement.classList.remove('no-js');

initValidation();
initPostcodeLookups();
initfilterCalendar();
initBookingCalendar();
initSupplierCalendar();
initStickyBar();
window.initBookingCalendar = initBookingCalendar;
experienceAnimationViewportCheck();
turbolinksScrollPersistence();
initTabNavigation();

window.initMap = checkForInitYuupMap;
